import React from 'react'
import { Form, Select } from 'antd'
import { ShelterContextData } from 'context/ShelterContext'
import { PartnerKeyType } from 'interfaces/IIntegration'
import { DEFAULT_SELECT_FILTER_OPTION } from 'helpers/form-fields.helper'

type IntegrationFieldProps = {
  shelterContext: ShelterContextData
  /** Whether the integration select is clearable. Characteristic omits it. Defaults to true. */
  allowClear?: boolean
}

/**
 * Shelter Buddy integration picker, bound to `integration_uuid`. Only shown once a
 * shelter is picked and the partner is SHELTER_BUDDY; defaults to the shelter's
 * main integration. Used solely to load the external option list.
 */
export const IntegrationField = ({ shelterContext, allowClear = true }: IntegrationFieldProps) => (
  <Form.Item
    noStyle
    shouldUpdate={(prev, cur) =>
      prev.shelter_uuid !== cur.shelter_uuid || prev.partner_key !== cur.partner_key
    }
  >
    {({ getFieldValue }) => {
      const shelterUuid: string | undefined = getFieldValue('shelter_uuid')
      const partnerKey: PartnerKeyType | undefined = getFieldValue('partner_key')

      if (!shelterUuid || partnerKey !== 'SHELTER_BUDDY') return null

      const integrationList = shelterContext.shelters
        ?.find(shelter => shelter.uuid === shelterUuid)
        ?.organization_integrations
        ?.filter(v => v.partner_key === partnerKey) ?? []

      const integrationOptions = integrationList.map(v => ({
        label: `${v.main ? '(MAIN) ' : ''}${v.description || ''} - ${v.uuid}`,
        value: v.uuid,
      }))

      const mainIntegrationUuid = integrationList.find(v => v.main)?.uuid

      return (
        <Form.Item
          label="Integration (only to load external list)"
          name="integration_uuid"
          initialValue={mainIntegrationUuid}
        >
          <Select
            allowClear={allowClear}
            placeholder="Select an integration"
            options={integrationOptions}
            showSearch
            filterOption={DEFAULT_SELECT_FILTER_OPTION}
          />
        </Form.Item>
      )
    }}
  </Form.Item>
)
